import React from 'react';
import { motion } from 'framer-motion';

const SocialProof = () => (
  <section className="py-16 bg-slate-50 border-y border-slate-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="max-w-2xl mx-auto text-center"
      >
        <p className="text-slate-500 text-sm font-semibold uppercase tracking-widest mb-4">Designed for businesses that can't afford to miss a call</p>
        <p className="text-slate-600 leading-relaxed text-lg mb-6">
          Businesses that miss calls lose jobs, leads, and commissions — often without knowing it. Valtivo ensures every call is captured, every detail is structured, and your team always knows who called and why.
        </p>
        <div className="inline-block bg-white border border-slate-200 rounded-xl px-6 py-4 text-slate-700 text-sm font-medium shadow-sm">
          Designed to handle 60–70% of routine inbound calls automatically, so your team focuses on what actually needs a human.
        </div>
      </motion.div>
    </div>
  </section>
);

export default SocialProof;